module.exports = __webpack_public_path__ + "static/helpdesk-2-eb7f2a1e0668e5e9f127ead5d5644388.gif";